import shop from "../../api/shop";

// initial state
// shape: [{ id, quantity }]
const state = {
  items: [],
  checkoutStatus: null,
  isShowCartDrawer: false,
};

// getters
const getters = {
  cartProducts: (state, getters, rootState) => {
    return state.items;
  },
  // cartProducts: (state, getters, rootState) => {
  //   return state.items.map(({ id, quantity }) => {
  //     const product = rootState.products.all.find(product => product.id === id);
  //     return {
  //       title: product.title,
  //       price: product.price,
  //       quantity
  //     };
  //   });
  // },

  cartTotalPrice: (state, getters) => {
    return getters.cartProducts.reduce((total, product) => {
      return total + product.price * product.cartQty;
    }, 0);
  },
  cartTotalQuantity: (state, getters) => {
    return getters.cartProducts.reduce((total, product) => {
      return total + product.cartQty;
    }, 0);
  },
  cartTotalUniqueQuantity: (state, getters) => {
    return getters.cartProducts.length;
  },
  cartProductIds: (state, getters) => {
    return getters.cartTotalUniqueQuantity > 0
      ? getters.cartProducts.map((x) => x.id)
      : [];
  },
  cartCategoryQuantityCount: (state, getters) => (categoryId) => {
    var result = [];

    getters.cartProducts.reduce(function(res, value) {
      if (!res[value.category_id]) {
        res[value.category_id] = { category_id: value.category_id, cartQty: 0 };
        result.push(res[value.category_id]);
      }
      res[value.category_id].cartQty += value.cartQty;
      return res;
    }, {});

    if (categoryId) {
      const matchedCategory = result.find((x) => x.category_id == categoryId);
      result = matchedCategory ? matchedCategory.cartQty : 0;
    }

    return result;
  },
  isShowCartDrawer: (state) => state.isShowCartDrawer,
  isShowFooterCart: (state, getters) =>
    getters.cartTotalQuantity > 0 && !getters.isShowCartDrawer,
  cartSummary: (state, getters) => {
    const deliveryFee = 0;
    const cartSummary = getters.cartProducts.reduce(
      (res, value) => {
        res["subTotal"] += value.cartQty * value.price;
        return res;
      },
      { subTotal: 0 }
    );

    return {
      deliveryFee,
      total: deliveryFee + cartSummary.subTotal,
      ...cartSummary,
    };
  },
};

// actions
const actions = {
  checkout({ commit, state }, products) {
    const savedCartItems = [...state.items];
    commit("setCheckoutStatus", null);
    // empty cart
    commit("setCartItems", { items: [] });
    shop.buyProducts(
      products,
      () => commit("setCheckoutStatus", "successful"),
      () => {
        commit("setCheckoutStatus", "failed");
        // rollback to the cart saved before sending the request
        commit("setCartItems", { items: savedCartItems });
      }
    );
  },

  addProductToCart({ state, commit }, { product, quantityIncrementOnly }) {
    const defaultServiceType = {
      id: 1,
      title: "Iron and Pressing",
      default: 1,
    };
    if (!product.cartServiceType) {
      product.cartServiceType = defaultServiceType;
    }

    if (quantityIncrementOnly === true) {
      // console.log("ha");
      product.cartQty += 1;
    }

    if (!product.cartQty) {
      product.cartQty = 1;
    }

    const cartItem = state.items.find((item) => item.id === product.id);
    if (!cartItem) {
      // console.log("cart e nai");
      commit("pushProductToCart", product);
    } else {
      // console.log("cart e ase");
      const newItems = state.items.map((obj) => {
        return product.id == obj.id ? product : obj;
      });
      commit("setCartItems", { items: newItems });
    }

    commit("products/updateAProduct", product, { root: true });
  },
  removeProductFromCart({ state, commit }, product) {
    if (!(product.cartServiceType && product.cartQty)) {
      return;
    }
    const newItems = state.items.filter((obj) => product.id != obj.id);
    commit("setCartItems", { items: newItems });
    commit("products/removeCartProperties", product, { root: true });
  },
  removeAllProductsFromCart({ state, commit, getters, dispatch }) {
    getters.cartProducts.forEach((product) => {
      dispatch("removeProductFromCart", product);
    });
  },
  addProductToCart1111({ state, commit }, product) {
    commit("setCheckoutStatus", null);
    if (product.inventory > 0) {
      const cartItem = state.items.find((item) => item.id === product.id);
      if (!cartItem) {
        commit("pushProductToCart", { id: product.id });
      } else {
        commit("incrementItemQuantity", cartItem);
      }
      // remove 1 item from stock
      commit(
        "products/decrementProductInventory",
        { id: product.id },
        { root: true }
      );
    }
  },
  showCartDrawer({ commit }, isShow) {
    commit("setIsShowCartDrawer", isShow);
  },
  incrementDecrementItemQuantity({ commit, getters }, { id, operator }) {
    const cartItem = getters.cartProducts
      .map((item, index) => {
        if (item.id == id) {
          item.cartQty = operator == "-" ? item.cartQty - 1 : item.cartQty + 1;
        }
        return item;
      })
      .filter((x) => x.cartQty > 0);
    commit("setCartItems", { items: cartItem });
    // console.log("incrementDecrementItemQuantity: ", cartItem);
  },
};

// mutations
const mutations = {
  pushProductToCart(state, newItem) {
    state.items.push(newItem);
  },
  pushProductToCart1111(state, { id }) {
    state.items.push({
      id,
      quantity: 1,
    });
  },

  incrementItemQuantity(state, { id }) {
    const cartItem = state.items.find((item) => item.id === id);
    cartItem.quantity++;
  },

  setCartItems(state, { items }) {
    state.items = items;
  },

  setCheckoutStatus(state, status) {
    state.checkoutStatus = status;
  },

  setIsShowCartDrawer(state, isShow) {
    state.isShowCartDrawer = isShow;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
